<template>
  <ol class="steps">
    <li
      v-for="(step, index) in steps"
      :key="`${step}-${index}`"
      class="step-wrapper"
    >
      <button
        v-scroll-to="{ el: `#form-plain-step-${step.stepId}` }"
        class="step"
        :class="{
          'is-active': isActive(step, index),
          'completed': stepsPassed[step.stepId],
          'has-error': hasError(step.stepId),
        }"
        :disabled="!isClickable(step, index)"
        @click.prevent
      >
        <span class="label">
          {{ step.stepLabel }}
        </span>
      </button>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'radio',
  props: {
    steps: {
      type: Array,
      required: true,
    },
    formObserver: {
      type: Object,
      required: true,
    },
    stepsObservers: {
      type: Object,
      required: true,
    },
    stepsPassed: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isActive (step, index) {
      if (this.stepsPassed[step.stepId] === true) return false;
      const prevStep = this.steps[index - 1];
      if (!prevStep) return true;
      return this.stepsPassed[prevStep.stepId];
    },
    isClickable (step, index) {
      if (this.stepsPassed[step.stepId] === true) return true;
      if (this.isActive(step, index)) return true;
      return false;
    },
    hasError (stepId) {
      return this.stepsObservers[stepId] && this.stepsObservers[stepId].failed;
    },
  },
};
</script>

<style lang="scss">
.steps {
  display: flex;
  justify-content: center;
  padding: 16px 42px !important;
  counter-reset: counter;

  .step-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 332px;

    &::after {
      content: "";
      width: calc(100% - 56px);
      margin: 0 10px;
      height: 1px;
      background-color: #d0d1d8;
    }

    &:last-child {
      max-width: 36px;
    }

    .step {
      position: relative;

      &::before {
        counter-increment: counter;
        content: counter(counter);
        display: block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        background-color: #818d97;
        border-radius: 50%;
        text-align: center;
        color: $clr-white;
        font-size: 10px;
        font-weight: 700;
      }

      .label {
        position: absolute;
        left: 50%;
        top: calc(100% + 4px);
        transform: translateX(-50%);
        white-space: nowrap;
        font-size: 10px;
      }

      &.is-active,
      &.completed {
        &::before {
          background-color: var(--v-primary-base);
        }

        .label {
          font-weight: 500;
        }
      }

      &.completed {
        &::before {
          font-size: 0;
        }

        &::after {
          content: '';
          display: block;
          width: 10px;
          height: 5px;
          border-style: solid;
          border-color: #fff;
          border-width: 0 0 2px 2px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(-45deg);
        }
      }

      &.has-error {
        color: var(--v-error-base, $clr-error);

        &::before {
          background-color: var(--v-error-base, $clr-error);
        }
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .steps {
    .step-wrapper {
      &::after {
        width: calc(100% - 76px);
        margin: 0 20px;
      }

      .step {
        &::before {
          width: 36px;
          height: 36px;
          line-height: 36px;
          font-size: 16px;
        }

        .label {
          font-size: 14px;
        }

        &.completed {
          &::after {
            width: 16px;
            height: 7px;
          }
        }
      }
    }
  }
}
</style>
